import { get } from '../../shared/api';
import { DefaultResponseDTO } from '../../shared/constants';

export const getTimezonesRequest = (): Promise<DefaultResponseDTO<string[]>> => {
  return get<DefaultResponseDTO<string[]>>(`/settings/timezones`);
};
